import React, { memo, useContext, useState } from "react";
import { Menu, MenuItem } from '@mui/material';
import { makeStyles } from "@material-ui/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Box from "@material-ui/core/Box";
import { IconButton } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { renderTime } from "../../utils/index";
import { EaseAppContext } from '../../EaseApp/index';
import { useSelector, useDispatch } from "../../EaseApp/index";
import MessageActions from "../../redux/message";
import SessionActions from "../../redux/session";
import GlobalPropsActions from "../../redux/globalProps";
import i18next from "i18next";
import muteImg from '../../common/images/gray@2x.png';
var useStyles = makeStyles(function (theme) {
  return {
    paper: {
      margin: '5px',
      paddingRight: '20px',
      borderRadius: '20px',
      display: 'flex'
    },
    moreVertStyle: {
      width: '15px',
      height: '15px',
      backgroundColor: '#f0f2f4',
      boxShadow: '1px 1px 10px rgb(0 0 0 / 30%)',
      '&:hover': {
        backgroundColor: '#ffffff'
      }
    },
    listItem: {
      padding: "0 14px",
      borderRadius: '20px',
      '& .Mui-selected': {
        backgroundColor: 'rgba(255, 255, 255, 1) !important'
      }
    },
    itemBox: {
      display: "flex",
      flex: 1,
      height: "100%",
      alignItems: "center",
      boxSizing: "border-box",
      padding: '5px 0'
    },
    itemRightBox: {
      flex: 1
    },
    itemName: {
      fontSize: "16px",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    itemMsgBox: {
      position: "relative",
      height: "20px",
      display: "flex",
      alignItems: "center"
    },
    time: {
      display: "inline-block",
      height: "17px",
      fontSize: "12px",
      color: "rgba(1, 1, 1, .6)",
      marginRight: "2px"
    },
    itemMsg: {
      display: "inline-block",
      height: "20px",
      overflow: "hidden",
      color: "rgba(1, 1, 1, .6)",
      width: "calc(100% - 18px)",
      fontSize: "14px",
      wordBreak: 'break-all'
    },
    unreadNum: {
      color: "#fff",
      background: "rgba(245, 12, 205, 1)",
      display: "inline-block",
      height: "16px",
      borderRadius: "8px",
      fontSize: "10px",
      minWidth: "16px",
      textAlign: "center",
      position: "absolute",
      right: "0"
    },
    muteImgStyle: {
      width: '12px',
      marginLeft: '2px',
      height: '12px'
    }
  };
});

function SessionItem(props) {
  var _presenceExt$session$, _session$lastMessage, _session$lastMessage2, _session$lastMessage3, _presenceExt$session$2;

  var easeAppProps = useContext(EaseAppContext);
  var isShowUnread = easeAppProps.isShowUnread,
      unreadType = easeAppProps.unreadType;
  var currentVal = props.currentVal,
      handleListItemClick = props.handleListItemClick,
      deleteSessionClick = props.deleteSessionClick;
  var session = currentVal.session,
      index = currentVal.index,
      currentSessionIndex = currentVal.currentSessionIndex,
      avatarSrc = currentVal.avatarSrc;
  var classes = useStyles();
  var dispatch = useDispatch();

  var _useState = useState(false),
      isShowMoreVertStyle = _useState[0],
      setIsShowMoreVertStyle = _useState[1];

  var _useState2 = useState(null),
      sessionEl = _useState2[0],
      setSessionEl = _useState2[1];

  var menuList = [{
    name: i18next.t('Delete Session'),
    key: '0',
    value: 'deleteSession'
  }];
  var globalProps = useSelector(function (state) {
    var _state$global;

    return (_state$global = state.global) === null || _state$global === void 0 ? void 0 : _state$global.globalProps;
  });
  var presenceExt = globalProps.presenceExt;

  var onClickMenuItem = function onClickMenuItem(option, _session) {
    return function (e) {
      var value = option.value;
      e.preventDefault();
      e.stopPropagation();

      switch (value) {
        case 'deleteSession':
          deleteSessionClick(_session);
          dispatch(MessageActions.clearMessage(_session.sessionType, _session.sessionId));
          dispatch(SessionActions.deleteSession(_session.sessionId));
          index === currentSessionIndex && dispatch(GlobalPropsActions.setGlobalProps({
            to: null
          }));
          setSessionEl(null);
          setIsShowMoreVertStyle(false);
          break;

        default:
          break;
      }
    };
  };

  var showMoreVert = function showMoreVert(e) {
    e.preventDefault();
    e.stopPropagation();
    setSessionEl(e.currentTarget);
  };

  var closeSession = function closeSession(e) {
    e.preventDefault();
    e.stopPropagation();
    setSessionEl(null);
  };

  var renderMenu = function renderMenu(_session) {
    return /*#__PURE__*/React.createElement(Menu, {
      id: "simple-menu",
      anchorEl: sessionEl,
      keepMounted: true,
      open: Boolean(sessionEl),
      onClose: function onClose(e) {
        return closeSession(e);
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      }
    }, menuList && menuList.map(function (option, index) {
      return /*#__PURE__*/React.createElement(MenuItem, {
        onClick: onClickMenuItem(option, _session),
        key: index
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "inherit",
        noWrap: true
      }, i18next.t(option.name)));
    }));
  };

  return /*#__PURE__*/React.createElement(ListItem, {
    key: session.sessionId,
    selected: currentSessionIndex === index,
    onClick: function onClick(event) {
      return handleListItemClick(event, index, session);
    },
    className: classes.listItem,
    button: true,
    onMouseOver: function onMouseOver() {
      return setIsShowMoreVertStyle(true);
    },
    onMouseLeave: function onMouseLeave() {
      setIsShowMoreVertStyle(false);
      setSessionEl(null);
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.itemBox
  }, /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
    style: {
      borderRadius: "" + session.sessionType === "singleChat" ? "50%" : 'inherit'
    },
    alt: "" + (session.sessionName || session.name || session.sessionId),
    src: avatarSrc
  })), /*#__PURE__*/React.createElement(Box, {
    className: classes.itemRightBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.itemName
  }, /*#__PURE__*/React.createElement("span", null, session.sessionName || session.name || session.sessionId, presenceExt && ((_presenceExt$session$ = presenceExt[session.sessionId]) === null || _presenceExt$session$ === void 0 ? void 0 : _presenceExt$session$.muteFlag) ? /*#__PURE__*/React.createElement("img", {
    className: classes.muteImgStyle,
    alt: "",
    src: muteImg
  }) : null), /*#__PURE__*/React.createElement("span", {
    className: classes.time
  }, renderTime(session === null || session === void 0 ? void 0 : (_session$lastMessage = session.lastMessage) === null || _session$lastMessage === void 0 ? void 0 : _session$lastMessage.time))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.itemMsgBox
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.itemMsg
  }, session === null || session === void 0 ? void 0 : (_session$lastMessage2 = session.lastMessage) === null || _session$lastMessage2 === void 0 ? void 0 : (_session$lastMessage3 = _session$lastMessage2.body) === null || _session$lastMessage3 === void 0 ? void 0 : _session$lastMessage3.msg), isShowUnread && presenceExt && !((_presenceExt$session$2 = presenceExt[session.sessionId]) === null || _presenceExt$session$2 === void 0 ? void 0 : _presenceExt$session$2.muteFlag) && /*#__PURE__*/React.createElement("span", {
    className: classes.unreadNum,
    style: {
      display: session.unreadNum ? "inline-block" : "none"
    }
  }, unreadType ? session.unreadNum : null), isShowMoreVertStyle && /*#__PURE__*/React.createElement(IconButton, {
    className: classes.moreVertStyle,
    onClick: function onClick(e) {
      return showMoreVert(e);
    }
  }, /*#__PURE__*/React.createElement(MoreVertIcon, {
    fontSize: "small"
  })), renderMenu(session)))));
}

export default memo(SessionItem);